<footer class="landing-footer bg-gray-950 text-gray-400 px-[112px]">
  <div
    class="landing-footer-top flex flex-col md:flex-row justify-between py-16 gap-5"
  >
    <div>
      <img class="pb-8" [src]="assetUrl + 'icons/logo-white.svg'" alt="Logo" />
      <p class="pb-8 w-2/3 text-gray-400">
        Want to stay in the know on all things gloget?
      </p>
      <small class="font-semibold text-white">Stay up to date</small>
      <div class="flex flex-col md:flex-row w-1/2 md:w-full pt-4 gap-4">
        <input
          class="flex mr-4 w-2/3 min-w-[200px]"
          type="email"
          name="email"
          id="email"
          placeholder="Enter your email"
          aria-label="Email address"
        />
        <button
          class="px-4 py-[10px] shadow rounded-3xl bg-white text-gray-700"
        >
          Subscribe
        </button>
      </div>
    </div>
    <div class="flex justify-between">
      <nav class="flex flex-col text-md w-[144px] pr-8">
        <ul>
          <li class="pb-3">
            <a routerLink="/explore" class="text-gray-400">Explore</a>
          </li>
          <li class="pb-3">
            <a routerLink="/why-us" class="text-gray-400">Why Us</a>
          </li>
          <li class="pb-3">
            <a routerLink="" class="text-gray-400">About Us</a>
          </li>
          <li class="pb-3">
            <a routerLink="/contact" class="text-gray-400">Contact Us</a>
          </li>
          <li class="pb-3"><a routerLink="/faq" class="text-gray-400">FAQ</a></li>
        </ul>
      </nav>
      <nav class="flex flex-col text-md w-[144px]">
        <ul>
          <li class="pb-3">
            <a routerLink="/customer" class="text-gray-400">Customer</a>
          </li>
          <li class="pb-3">
            <a routerLink="/business" class="text-gray-400">Business</a>
          </li>
          <li class="pb-3">
            <a routerLink="/staff" class="text-gray-400">Staff</a>
          </li>
          <li class="pb-3">
            <a routerLink="/staff" class="text-gray-400">gloget Rewards</a>
          </li>
          <li class="pb-3">
            <a routerLink="/staff" class="text-gray-400">Industry News</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <div
    class="landing-footer-bottom flex justify-between border-t border-t-gray-800 pt-8 pb-12"
  >
    <div>
      <p class="text-gray-400">© 2025 gloget. All rights reserved.</p>
    </div>
    <div class="flex">
      <ul class="flex">
        <li class="pl-4"><a href="#" class="text-gray-400">Terms</a></li>
        <li class="pl-4"><a href="#" class="text-gray-400">Privacy</a></li>
        <li class="pl-4"><a href="#" class="text-gray-400">Cookies</a></li>
      </ul>
    </div>
  </div>
</footer>
